/* eslint-disable no-restricted-syntax */
import React, {memo} from 'react';
import cn from 'classnames';

import CreateCtx from 'coreUtils/createCtx';
import {withTryCatch} from 'coreUtils/reactUtils';

import CustomerServiceLinks from 'brandComponents/CustomerServiceLinks';
import ShowOrHideOnBreakpoint from 'brandComponents/Responsive/ShowOrHideOnBreakpoint';

import {useParsedNavigationProps} from './hooks';
import {INavigationItemOldProps, INavigationItemProps} from './INavigationItem';
import {NavigationItemContent, NavigationItemList} from './Subcomponents';

export const [useParentProvider, ParentProvider] = CreateCtx<INavigationItemProps>();

const NavigationItem = (props: INavigationItemOldProps) => {
	const parent = useParentProvider(true);
	const parsedProps = useParsedNavigationProps({...props, parent});

	if (!parsedProps?.parent?.id && parsedProps.title) {
		return (
			<ParentProvider value={parsedProps}>
				<ShowOrHideOnBreakpoint query=">=xx-large">
					<NavigationItemList
						level="base"
						classNames={cn({'has-active': parsedProps.hasActive}, parsedProps.animationClasses)}
						viewAll={parsedProps.viewAll}
					>
						<NavigationItemContent {...parsedProps}>{parsedProps.children}</NavigationItemContent>
					</NavigationItemList>
				</ShowOrHideOnBreakpoint>
			</ParentProvider>
		);
	}

	if (!parsedProps?.parent?.id && !parsedProps.title) {
		return (
			<ParentProvider value={parsedProps}>
				<NavigationItemList
					level="root"
					classNames={cn('navigation', {
						'has-active': parsedProps.hasActive,
						'has-multi-sub-lists': !!parsedProps.hasSubLists,
					})}
				>
					{parsedProps.children}

					{!!parsedProps.isInHeaderContext && (
						<ShowOrHideOnBreakpoint classNames="navigation__service-links" as="li" query="<xx-large">
							<CustomerServiceLinks />
						</ShowOrHideOnBreakpoint>
					)}
				</NavigationItemList>
			</ParentProvider>
		);
	}

	return (
		<ParentProvider value={parsedProps}>
			<NavigationItemContent {...parsedProps}>{parsedProps.children}</NavigationItemContent>
		</ParentProvider>
	);
};

export default memo(withTryCatch(NavigationItem), () => true);
